// Import the Firebase SDK
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// Your web app's Firebase configuration
// Replace these with your actual Firebase project details
const firebaseConfig = {
  apiKey: "AIzaSyDxdEu0FOczg5G4aU0gpDXRT_7inUXFKW8",
  authDomain: "socfirst-dec05.firebaseapp.com",
  projectId: "socfirst-dec05",
  storageBucket: "socfirst-dec05.firebasestorage.app",
  messagingSenderId: "872167218068",
  appId: "1:872167218068:web:33830ce812d9e6242e4d81"
};

// Initialize Firebase
export const firebaseApp = initializeApp(firebaseConfig);
export const auth = getAuth(firebaseApp);
export const db = getFirestore(firebaseApp);

export default firebaseApp;